<template>
<div class="main my">
  <!-- 添加产品 -->
  <form class="clear bcw ptw" @submit.prevent="checkForm" v-cloak>
    <van-cell-group>
      <van-field v-model="postForm.title" label="卡片名称" clearable placeholder="请输入" />
      <van-cell
        title="卡片类型"
        v-model="category"
        value="请选择"
        is-link
        @click="timePopupShow = true;"/>
      <van-field v-model="postForm.useNum" type="number" label="使用次数" clearable placeholder="选填" />
      <van-field v-model="postForm.price" type="number" label="价格" placeholder="请输入"><van-button slot="button" size="small" type="default" disabled>元</van-button></van-field>
      <van-field v-model="postForm.timeSpan" type="number" label="有效期" placeholder="选填"><van-button slot="button" size="small" type="default" disabled>天</van-button></van-field>
      <van-field
        label="卡片介绍"
        v-model="postForm.about"
        placeholder="请输入"
        type="textarea"
        rows="3"
        autosize/>
    </van-cell-group>
    <the-btnbar :loadSta="subSta"></the-btnbar>
  </form>

  <!-- 弹出层 -->
  <van-popup v-model="timePopupShow" position="bottom">
    <van-picker :columns="columns" show-toolbar @cancel="onCancel" @confirm="onConfirm" />
  </van-popup>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import TheBtnbar from './components/TheBtnBar';
import {
  Cell, CellGroup,Checkbox, CheckboxGroup,SwitchCell,Toast
} from 'vant';
Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(SwitchCell).use(Toast);

export default {
  components: {
    TheBtnbar
  },
  data() {
    return {
      subSta:false, //提交时 按钮状态
      timePopupShow:false,
      category:'请选择', //显示的职称名称
      columns:[], //分类
      postForm:{
        title:'',
        categoryId:'',
        timeSpan:'',
        useNum:'',
        about:'',
        price:'' 
      },
      id:this.$route.query && this.$route.query.id
    }
  },
  created(){
    // 获取分类
    this.$http.post('product_manage/getCardcategory').then(res => {
      if (!res.data.code) {
        let arr = res.data.value;
        arr.map(i=>{
          this.columns.push({
            text:i.name,
            value:i.id
          }) 
        })
      } else {
        Toast.fail(res.data.message);
      }
    })

    // const id = this.$route.query && this.$route.query.id
    if(this.id){
      // 编辑
      document.title='编辑产品'
      // 获取详情
      this.$http.post('product_manage/getCardInfo',{
        id:this.id
      }).then(res => {
        if (!res.data.code) {
          this.postForm = res.data.value
        } else {
          Toast.fail(res.data.message);
        }
      })
    }else{
      // 添加
    }
  },
  methods: {
    searchType(id){
      // 判断类型id 显示文字
      this.columns.map(i=>{
        if(i.value == id){
          this.category = i.text
        }
      })
    },
    onConfirm(value, index) {
      this.category = value.text
      this.postForm.categoryId = value.value
      this.timePopupShow = false
    },
    onCancel() {
      this.timePopupShow = false
    },
    checkForm: function(){
      // console.log(this.postForm)

      let _this = this
      let temp = JSON.parse(JSON.stringify(_this.postForm))

      _this.subSta = true
      // 提交表单
      if(this.id){
        //编辑
        temp.id = this.id
        _this.$http.post('product_manage/editCard',temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'编辑成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1)
            }, 1000) 
          }else{
            Toast(res.data.message)
            _this.subSta = false
          }
        })
      }else{
        // 添加
        _this.$http.post('product_manage/addCard',temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'添加成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1)
            }, 1000) 
          }else{
            Toast(res.data.message)
            _this.subSta = false
          }
        })
      }
    }
  },
  computed: {
    categoryStatus() {
      const { columns, postForm } = this  //同时监听到 分类变化和postform变化，代表接口回调完成
      return {
        columns,
        postForm
      }
    }
  },
  watch:{
    categoryStatus:{
      handler: function(val) {
        // console.log('address change: ', val)
        this.searchType(this.postForm.categoryId)
      },
      deep: true
    }
    // columns(val){
    //   this.searchType(this.postForm.categoryId)
    // },
    // postForm(val){
    //   this.searchType(this.postForm.categoryId)
    // }
  }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/manage/SetProductAdd.vue